import axiosInstance from './axios.service';

const newsletterService = {
  subscribe: async email => {
    const { data } = await axiosInstance.post('/api/newsletter/subscribe', { email });
    return data;
  },

  list: async () => {
    const { data } = await axiosInstance.get('/api/newsletter');
    return data;
  },

  remove: async id => {
    const { data } = await axiosInstance.delete(`/api/newsletter/${id}`);
    return data;
  },
};

export default newsletterService;
